import {
	GOALS_APP_SAVED_VIEW_FEED_PATH_PREFIX,
	PROJECTS_APP_SAVED_VIEW_FEED_PATH_PREFIX,
	SAVED_VIEW_FEED_PAGE,
	SAVED_VIEW_FEED_PATH_PREFIX,
} from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';
import { SiteHomePageRoute } from '@townsquare/router/route-types';

export const savedViewsUpdatesRoute: SiteHomePageRoute = createSiteRoute({
	exact: true,
	name: SAVED_VIEW_FEED_PAGE,
	path: `${SAVED_VIEW_FEED_PATH_PREFIX}/:uuid`,
	layout: 'home',
	subproduct: 'townsquare-tags',
});

export const goalsAppSavedViewsUpdatesRoute: SiteHomePageRoute = createSiteRoute({
	exact: true,
	name: SAVED_VIEW_FEED_PAGE,
	path: `${GOALS_APP_SAVED_VIEW_FEED_PATH_PREFIX}/:uuid`,
	capabilities: ['goals_app:access'],
	layout: 'home',
	subproduct: 'townsquare-goals',
	enableRestrictedFallback: true,
});

export const projectsAppSavedViewsUpdatesRoute: SiteHomePageRoute = createSiteRoute({
	exact: true,
	name: SAVED_VIEW_FEED_PAGE,
	path: `${PROJECTS_APP_SAVED_VIEW_FEED_PATH_PREFIX}/:uuid`,
	capabilities: ['projects_app:access'],
	layout: 'home',
	subproduct: 'townsquare-projects',
	enableRestrictedFallback: true,
});
